import React from 'react';

const LinkedIn = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 25 25"
		fill="none"
		{...props}
	>
		<path
			fill="#6B6279"
			d="M22.336.412H1.884c-.98 0-1.771.773-1.771 1.73v20.535c0 .957.792 1.735 1.771 1.735h20.452c.98 0 1.777-.778 1.777-1.73V2.142c0-.957-.797-1.73-1.777-1.73ZM7.233 20.863H3.67V9.407h3.563v11.456ZM5.452 7.846a2.064 2.064 0 1 1 0-4.125 2.063 2.063 0 0 1 0 4.125Zm15.112 13.017h-3.558v-5.569c0-1.326-.023-3.037-1.851-3.037-1.852 0-2.133 1.448-2.133 2.944v5.662H9.469V9.407h3.412v1.566h.047c.474-.9 1.636-1.852 3.366-1.852 3.604 0 4.27 2.372 4.27 5.456v6.286Z"
		/>
	</svg>
)

export default LinkedIn;
